import type { SVGProps } from 'react';

const SvgRecentAssets = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M11 15.002H6c-.55 0-1-.45-1-1v-.5l3.03-2.28 2.41 1.61c.4.26.93.21 1.26-.12l1-1a.996.996 0 1 0-1.41-1.41l-.42.42-2.32-1.54a.99.99 0 0 0-1.15.03l-2.4 1.8v-5.01c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v2c0 .55.45 1 1 1s1-.45 1-1v-2c0-1.65-1.35-3-3-3H6c-1.65 0-3 1.35-3 3v8c0 1.65 1.35 3 3 3h5c.55 0 1-.45 1-1s-.45-1-1-1"
    />
    <path
      fill="currentcolor"
      d="M11.5 9.002a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m4.5 4c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h1.5c.55 0 1-.45 1-1s-.45-1-1-1H17v-1c0-.55-.45-1-1-1"
    />
    <path
      fill="currentcolor"
      d="M16 10.002c-.55 0-1 .45-1 1s.45 1 1 1c2.21 0 4 1.79 4 4a3.999 3.999 0 0 1-6.4 3.2c-.44-.33-1.07-.24-1.4.2s-.24 1.07.2 1.4c1.04.79 2.29 1.2 3.6 1.2 3.31 0 6-2.69 6-6s-2.69-6-6-6"
    />
  </svg>
);
export default SvgRecentAssets;
